export default __webpack_public_path__ + "static/media/blueberry.82cdfdb3.ogg";